<template>
  <div v-if="diskUsage" class="disk-usage-card">
    <div class="disk-header">
      <span class="disk-label">💾 فضای مصرفی</span>
      <span class="disk-text">
        {{ diskUsage.used_formatted }} از {{ diskUsage.quota_formatted }}
      </span>
    </div>
    <div class="disk-bar">
      <div
          class="disk-fill"
          :class="barClass"
          :style="{ width: diskUsage.used_percentage + '%' }"
      ></div>
    </div>
    <div class="disk-footer">
      <span>فضای خالی: {{ diskUsage.free_formatted }}</span>
      <span>{{ diskUsage.used_percentage }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiskUsageBar',

  props: {
    diskUsage: {
      type: Object,
      default: null
    }
  },

  computed: {
    barClass: function() {
      if (!this.diskUsage) return '';
      var p = this.diskUsage.used_percentage;
      if (p >= 90) return 'danger';
      if (p >= 70) return 'warning';
      return 'success';
    }
  }
};
</script>

<style scoped>
.disk-usage-card {
  background: white;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}

.disk-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
}

.disk-label { font-weight: 600; color: #2c3e50; }
.disk-text { color: #606266; }

.disk-bar {
  height: 10px;
  background: #f0f0f0;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 8px;
}

.disk-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 0.5s ease;
}

.disk-fill.success { background: linear-gradient(90deg, #67c23a, #85ce61); }
.disk-fill.warning { background: linear-gradient(90deg, #e6a23c, #ebb563); }
.disk-fill.danger { background: linear-gradient(90deg, #f56c6c, #f78989); }

.disk-footer {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #909399;
}
</style>